import base from "../baseurl";
import token from "../getTk";

const Create = async (id) => {
  const tokenA = token.get();
  const api = base.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set("jwt", `${tokenA}`);
        },
      ],
    },
  });
  const newS = await api
    .post("sport-events/delete", {
      json: { id },
      timeout: false,
    })
    .json();
  console.log("delete", newS);
  return newS;
};

export default Create;
